import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import subscribe from '../images/premium.png';
import rentIcon from '../images/rentIcon.png';
import test from '../images/chullTest23.jpg';
import Cookies from 'js-cookie';
import { Contextone } from './Context';
import { ShimmerThumbnail, ShimmerPostList, ShimmerPostItem } from 'react-shimmer-effects';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styled from 'styled-components';
import chullLogo from '../images/chullLogo1.png';
import chullLogoLandscape from '../images/chullLandscape_resize.png';
import sidesLogoLandscape from '../images/4sidesLogoLandscape.png';
import potrait from '../images/logoPotrait.png';
import globalSetting from "../configuration.js";

const ShimmerContainer = styled.div`
  height: 230px;
  width: 178px;
  margin: 0 10px 30px 0;
  background: #3a3a3a;
  background-image: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
  background-repeat: no-repeat;
  background-size: 1900px 800px;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: ease-in-out;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

const ShimmerRow = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
        {[...Array(6)].map((_, index) => (
            <ShimmerContainer key={index} />
        ))}
    </div>
);

const Moviecard = React.memo(({ data, loading, bannervisible, type, loadMoreData, pageUrl }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const userid = Cookies.get('userid');
    const countercontext = useContext(Contextone);
    let logo = countercontext.isLogo;
    let LandscapeLogo = countercontext.isLogo;
    const host = window.location.host;
    const scrollContainerRef = useRef(null);

    let scrollSize = 0;


    const isurl = countercontext.isDomain;
    const apiUrl = `https://${isurl}`;
    

    if(apiUrl == "https://chull.ottsnap.in"){
        logo = chullLogo;
        LandscapeLogo = chullLogoLandscape;
    }

    if(apiUrl == "https://4sides.ottsnap.in"){
        LandscapeLogo = sidesLogoLandscape;
    }



    useEffect(() => {

        if (!scrollContainerRef.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && pageUrl != null && !loading) {
                    loadMoreData();
                }
            },
            { threshold: 0.1 }
        );

        observer.observe(scrollContainerRef.current);

        return () => {
            observer.disconnect();
        };
    }, [loading, loadMoreData, pageUrl]);

    const handleImageLoad = (index) => {
        setImageLoaded((prevState) => ({
            ...prevState,
            [index]: true,
        }));
    };

    const [imageLoaded, setImageLoaded] = useState({});

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (windowWidth <= 480) {
        scrollSize = 1;
    } else if (windowWidth > 480 && windowWidth <= 768) {
        scrollSize = 1;
    } else {
        scrollSize = 0;
    }

    const scrollRefs = useRef([]);
    const scrollLeft = (index) => {
        scrollRefs.current[index].scrollBy({ left: -1000, behavior: 'smooth' });
    };

    const scrollRight = (index) => {
        scrollRefs.current[index].scrollBy({ left: 1000, behavior: 'smooth' });
    };

    const addDefaultImg = ev => {
        ev.target.src = logo;
    }

    
    const slugify = (text) => {
        return text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    };

    const decodeVal = (str) => {
        return btoa(str);
    }

    const createEncodedData = (id, type_id, video_type, upcoming_type) => {
        const str = `${id}-${type_id}-${video_type}-${upcoming_type}`;
        return decodeVal(str);
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <ShimmerRow />
            </div>
        );
    }

    if (!data) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh', color: 'white' }}>
        <h2>No data available</h2>
    </div>;

    const filteredData = data
        .filter(mtype =>
            ['potrait_1', 'potrait', 'square', 'landscape_1', 'landscape'].includes(mtype.screen_layout) ||
            [3, 6, 4].includes(mtype.video_type) || ['0', '1'].includes(mtype.is_top_10)
        )
        .sort((a, b) => a.section_order - b.section_order);

    if (type === undefined) {
        type = 'khabar'
    }

    return (
        <>
            <div className={bannervisible ? "container-row" : "container-row1"}>
                {filteredData.map((mtype, index) => {
                    const setScrollRef = (el) => {
                        scrollRefs.current[index] = el;
                    };

                    if ((['potrait_1',].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && ![1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        <h4 className="Movie-heading">
                                            {mtype.title}
                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>


                                        </h4>

                                        <div className="scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>
                                                                    {movie.thumbnail_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                   {movie.thumbnail_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.thumbnail_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                )}
                                                            </Link>
                                                        )}

                                                    </div>
                                                </React.Fragment>
                                            ))}
                                        </div>

                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );
                    } else if ((['potrait'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && ![1].includes(mtype.is_top_10)) {
                        return (
                            <div key={mtype.id} className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        <h4 key={mtype.id} className="Movie-heading">
                                            {mtype.title}
                                            <i
                                                className="bi bi-chevron-right chevron-icon"
                                                style={{ color: 'white', marginLeft: '5px' }}
                                            ></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All{' '}
                                                    <i
                                                        className="bi bi-chevron-right"
                                                        style={{
                                                            color: '#deeb52',
                                                        }}
                                                    ></i>
                                                </h6>
                                            </Link>
                                        </h4>

                                        <div className="scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ? (
                                                            <div className="scroll-buttons-banner">
                                                                <button
                                                                    onClick={() => scrollLeft(index)}
                                                                    className="scroll-button left"
                                                                >
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button
                                                                    onClick={() => scrollRight(index)}
                                                                    className="scroll-button right"
                                                                >
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="scroll-buttons">
                                                                <button
                                                                    onClick={() => scrollLeft(index)}
                                                                    className="scroll-button left"
                                                                >
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button
                                                                    onClick={() => scrollRight(index)}
                                                                    className="scroll-button right"
                                                                >
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                        )
                                                    )}
                                                    <div
                                                        className="custom-div"
                                                        key={key}
                                                        id={`custom-div-${key}`}
                                                    >

                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link
                                                                    to={{
                                                                        pathname: '/live/0/0/0/0',
                                                                        state: { url: movie.video_320 },
                                                                    }}
                                                                >
                                                                    {movie.thumbnail ? (
                                                                        <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) :
                                                                        movie.thumbnail_1 ? (
                                                                            <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                                onLoad={() => handleImageLoad(key)}
                                                                                onError={addDefaultImg}
                                                                                className="img-top" alt="..." loading="lazy" />
                                                                        ) : (
                                                                            <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                        )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.thumbnail ? (
                                                                        <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) :
                                                                        movie.thumbnail_1 ? (
                                                                            <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                                onLoad={() => handleImageLoad(key)}
                                                                                onError={addDefaultImg}
                                                                                className="img-top" alt="..." loading="lazy" />
                                                                        ) : (
                                                                            <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                        )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link
                                                                to={`/${type}/${slugify(movie.name)}/${createEncodedData(
                                                                    movie.id,
                                                                    movie.type_id,
                                                                    movie.video_type,
                                                                    movie.upcoming_type
                                                                )}`}
                                                            >
                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-img ${movie.is_premium ? 'premium-style' : ''
                                                                            }`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) :
                                                                    movie.thumbnail_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                    )}

                                                            </Link>
                                                        )}

                                                    </div>
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </>
                                )}

                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );
                    } else if ((['square'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && ![1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        <h4 className="Movie-heading">
                                            {mtype.title}
                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>

                                        </h4>

                                        <div className="landscape-scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id || key}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : (
                                                                        <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : (
                                                                        <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-landscape ${movie.is_premium ? 'premium-style-landscape' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.landscape ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                ) : movie.landscape_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                )}
                                                            </Link>
                                                        )}


                                                    </div>
                                                </React.Fragment>

                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>

                        );
                    } else if ((['landscape'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && ![1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        <h4 className="Movie-heading">
                                            {mtype.title}
                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>

                                        </h4>

                                        <div className="landscape-scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id || key}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-landscape ${movie.is_premium ? 'premium-style-landscape' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.landscape ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.landscape_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                                )}
                                                            </Link>
                                                        )}


                                                    </div>
                                                </React.Fragment>

                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>

                        );
                    } else if ((['landscape_1'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && ![1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        <h4 className="Movie-heading">
                                            {mtype.title}

                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>

                                        </h4>

                                        <div className="landscape-scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                    {movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-landscape ${movie.is_premium ? 'premium-style-landscape' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.landscape_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                ) : movie.landscape ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={LandscapeLogo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                )}
                                                            </Link>
                                                        )}



                                                    </div>
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>

                        );
                    } else if ([3, 6, 4].includes(mtype.video_type) && ![7].includes(mtype.video_type)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        <h4 className="Movie-heading">
                                            {mtype.title}
                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>


                                        </h4>

                                        <div className="artist-container " ref={setScrollRef}>

                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="normalcustom-div" key={key}>
                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                    {movie.image ? (
                                                                        <img src={imageLoaded[key] ? movie.image : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top" alt="..." id={movie.id} style={{ height: '200px', borderRadius: '0px' }} />
                                                                    ) : (
                                                                        <img src={logo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.image ? (
                                                                        <img src={imageLoaded[key] ? movie.image : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top" alt="..." id={movie.id} style={{ height: '200px', borderRadius: '0px' }} />
                                                                    ) : (
                                                                        <img src={logo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={{ pathname: `/browse/${slugify(mtype.title)}/${slugify(movie.name)}/${createEncodedData(mtype.id, mtype.type_id, mtype.video_type, mtype.upcoming_type)}`, state: { id: movie.id, title: mtype.title } }}>
                                                                {movie.image ? (
                                                                    <img src={imageLoaded[key] ? movie.image : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="card-img-top" alt="..." id={movie.id} style={{ height: '200px', borderRadius: '0px' }} />
                                                                ) : (
                                                                    <img src={logo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                )}
                                                            </Link>
                                                        )}

                                                    </div>
                                                </React.Fragment>

                                            ))}

                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );


                    } else if ((['potrait_1'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && [1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        {/* <h4 className="movie-heading"> */}
                                        <h4 className="Movie-heading">
                                            {mtype.title}

                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>
                                        </h4>

                                        <div className="scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        <div className="number-overlay">{key + 1}</div>
                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                {movie.thumbnail_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                )}

                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.thumbnail_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                )}

                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.thumbnail_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" />
                                                                )}
                                                            </Link>
                                                        )}

                                                    </div>
                                                </React.Fragment>

                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );
                    } else if ((['potrait'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && [1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        {/* <h4 className="movie-heading"> */}
                                        <h4 className="Movie-heading">
                                            {mtype.title}

                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>
                                        </h4>

                                        <div className="scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ? (
                                                            <div className="scroll-buttons-banner">
                                                                <button
                                                                    onClick={() => scrollLeft(index)}
                                                                    className="scroll-button left"
                                                                >
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button
                                                                    onClick={() => scrollRight(index)}
                                                                    className="scroll-button right"
                                                                >
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="scroll-buttons">
                                                                <button
                                                                    onClick={() => scrollLeft(index)}
                                                                    className="scroll-button left"
                                                                >
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button
                                                                    onClick={() => scrollRight(index)}
                                                                    className="scroll-button right"
                                                                >
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                        )
                                                    )}
                                                    <div
                                                        className="custom-div"
                                                        key={key}
                                                        id={`custom-div-${key}`}
                                                    >
                                                        <div className="number-overlay">{key + 1}</div>
                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link
                                                                    to={{
                                                                        pathname: '/live/0/0/0/0',
                                                                        state: { url: movie.video_320 },
                                                                    }}
                                                                >
                                                                    {movie.thumbnail ? (
                                                                        <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                    ) :
                                                                        movie.thumbnail_1 ? (
                                                                            <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                                onLoad={() => handleImageLoad(key)}
                                                                                onError={addDefaultImg}
                                                                                className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                        ) : (
                                                                            <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                        )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.thumbnail ? (
                                                                        <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                    ) :
                                                                        movie.thumbnail_1 ? (
                                                                            <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                                onLoad={() => handleImageLoad(key)}
                                                                                onError={addDefaultImg}
                                                                                className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                        ) : (
                                                                            <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                        )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link
                                                                to={`/${type}/${slugify(movie.name)}/${createEncodedData(
                                                                    movie.id,
                                                                    movie.type_id,
                                                                    movie.video_type,
                                                                    movie.upcoming_type
                                                                )}`}
                                                            >
                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-img ${movie.is_premium ? 'premium-style' : ''
                                                                            }`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.thumbnail ? (
                                                                    <img src={imageLoaded[key] ? movie.thumbnail : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                ) :
                                                                    movie.thumbnail_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.thumbnail_1 : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                    ) : (
                                                                        <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '230px' }} />
                                                                    )}
                                                            </Link>
                                                        )}

                                                    </div>
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );
                    } else if ((['landscape_1'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && [1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        {/* <h4 className="movie-heading"> */}
                                        <h4 className="Movie-heading">
                                            {mtype.title}

                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>
                                        </h4>

                                        <div className="scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        <div className="number-overlay">{key + 1}</div>
                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                    {movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-landscape ${movie.is_premium ? 'premium-style-landscape' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.landscape_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                ) : movie.landscape ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={LandscapeLogo} className="card-img-top landscape_1" alt="..." loading="lazy" />
                                                                )}
                                                            </Link>
                                                        )}



                                                    </div>
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );
                    } else if ((['landscape'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && [1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        {/* <h4 className="movie-heading"> */}
                                        <h4 className="Movie-heading">
                                            {mtype.title}

                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>
                                        </h4>

                                        <div className="scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id || key}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        <div className="number-overlay-landscape">{key + 1}</div>
                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" />
                                                                    ) : (
                                                                        <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                                    )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-landscape ${movie.is_premium ? 'premium-style-landscape' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.landscape ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : movie.landscape_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape_1 : LandscapeLogo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" />
                                                                ) : (
                                                                    <img src={LandscapeLogo} className="img-top" alt="..." loading="lazy" />
                                                                )}
                                                            </Link>
                                                        )}


                                                    </div>
                                                </React.Fragment>

                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );
                    } else if ((['square'].includes(mtype.screen_layout) && mtype.data) && ![3, 6, 4,7].includes(mtype.video_type) && [1].includes(mtype.is_top_10)) {
                        return (
                            <div className='container-underRow' ref={scrollContainerRef}>
                                {mtype.data.length > 0 && (
                                    <>
                                        {/* <h4 className="movie-heading"> */}
                                        <h4 className="Movie-heading">
                                            {mtype.title}

                                            <i className="bi bi-chevron-right chevron-icon" style={{ color: 'white', marginLeft: '5px' }}></i>

                                            <Link to={`/View/${type}/${slugify(mtype.title)}/${mtype.id}`}>
                                                <h6 className="view-all">
                                                    View All <i className="bi bi-chevron-right" style={{ color: '#deeb52' }}></i>
                                                </h6>
                                            </Link>
                                        </h4>

                                        <div className="scroll-container" ref={setScrollRef}>
                                            {mtype.data.map((movie, key) => (
                                                <React.Fragment key={movie.id || key}>
                                                    {!scrollSize && mtype.data.length > 4 && (
                                                        mtype.banner_visible > 0 ?
                                                            <div className="scroll-buttons-banner">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div> :
                                                            <div className="scroll-buttons">
                                                                <button onClick={() => scrollLeft(index)} className="scroll-button left">
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button onClick={() => scrollRight(index)} className="scroll-button right">
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </div>
                                                    )}
                                                    <div className="custom-div" key={key} id={`custom-div-${key}`}>

                                                        <div className="number-overlay">{key + 1}</div>
                                                        {movie.is_live_url ? (
                                                            userid ? (
                                                                <Link to={{ pathname: '/live/0/0/0/0', state: { url: movie.video_320 } }}>

                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : (
                                                                        <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <Link to="/login">
                                                                    {movie.landscape ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : movie.landscape_1 ? (
                                                                        <img src={imageLoaded[key] ? movie.landscape_1 : logo}
                                                                            onLoad={() => handleImageLoad(key)}
                                                                            onError={addDefaultImg}
                                                                            className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    ) : (
                                                                        <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                    )}
                                                                </Link>
                                                            )
                                                        ) : (
                                                            <Link to={`/${type}/${slugify(movie.name)}/${createEncodedData(movie.id, movie.type_id, movie.video_type, movie.upcoming_type)}`}>

                                                                {(movie.is_premium || movie.is_rent !== 0) && (
                                                                    <img
                                                                        src={movie.is_premium ? subscribe : rentIcon}
                                                                        className={`premium-landscape ${movie.is_premium ? 'premium-style-landscape' : ''}`}
                                                                        alt="Premium/Rent Icon"
                                                                    />
                                                                )}
                                                                {movie.landscape ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                ) : movie.landscape_1 ? (
                                                                    <img src={imageLoaded[key] ? movie.landscape_1 : logo}
                                                                        onLoad={() => handleImageLoad(key)}
                                                                        onError={addDefaultImg}
                                                                        className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                ) : (
                                                                    <img src={logo} className="img-top" alt="..." loading="lazy" style={{ height: '130px' }} />
                                                                )}
                                                            </Link>
                                                        )}


                                                    </div>
                                                </React.Fragment>

                                            ))}
                                        </div>
                                    </>
                                )}
                                {mtype.data.length > 0 && mtype.banner_visible > 0 && (
                                    userid ? (
                                        mtype.banner_link_type && mtype.banner_backlink ? (
                                            <Link to={{ pathname: '/live/0/0/0/0', state: { url: mtype.banner_backlink } }}>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="..." />
                                                </div>
                                            </Link>
                                        ) : mtype.banner_link_type === 0 && mtype.banner_backlink ? (
                                            <>
                                                <a href={mtype.banner_backlink} target="_blank">
                                                    <div className='bannerDiv' index={index}>
                                                        <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                            onLoad={() => handleImageLoad(index)}
                                                            onError={addDefaultImg}
                                                            className="d-block w-100 banner" alt="..." />
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                                <div className='bannerDiv' index={index}>
                                                    <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={addDefaultImg}
                                                        className="d-block w-100 banner" alt="Banner" />
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <Link to="/login">
                                            <div className='bannerDiv' index={index}>
                                                <img src={imageLoaded[index] ? mtype.banner_image : logo}
                                                    onLoad={() => handleImageLoad(index)}
                                                    onError={addDefaultImg}
                                                    className="d-block w-100 banner" alt="..." />
                                            </div>
                                        </Link>
                                    )
                                )}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        </>
    );

});


export default Moviecard;

